import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RedefineYourRadiance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="27388" id="elevated-living-spaces" className="relative h-screen min-h-[600px] w-full overflow-hidden bg-background dark">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1613388/img/cinematic_bifold_doors.png)] bg-cover bg-center bg-no-repeat" />

      {}
      <div className="absolute inset-0 bg-gradient-to-r from-secondary/90 via-secondary/40 to-transparent" />

      {}
      <div ref={ref} className={`relative z-10 flex h-full flex-col items-center justify-center px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        <h1 className="mb-10 max-w-5xl font-serif text-5xl leading-[1.1] text-white md:text-[5rem]">
          Transform Your Home With a Modern Kitchen & Bi-Fold Doors
        </h1>

        <Button asChild className="h-auto rounded-none border border-primary bg-primary px-10 py-4 text-lg uppercase tracking-widest text-primary-foreground transition-all duration-300 hover:border-primary hover:bg-primary/90 hover:text-primary-foreground">
          <Link to="/ContactPage">Book Free Consultation</Link>
        </Button>
      </div>
    </section>;
}